// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import SignInController from "./sign_in_controller"
application.register("sign-in", SignInController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import PostalCodeController from "./postal_code_controller"
application.register("postal-code", PostalCodeController)

import LevelHierachyController from "./level_hierarchy_controller"
application.register("level-hierarchy", LevelHierachyController)

import AppUserHierarchyController from "./app_user_hierarchy_controller"
application.register("app-user-hierarchy", AppUserHierarchyController)

import CheckBoxController from "./checkbox_controller"
application.register("checkbox", CheckBoxController)

import ContractorHierarchyController from "./contractor_hierarchy_controller"
application.register("contractor-hierarchy", ContractorHierarchyController)
import FlatpickrController from "./flatpickr_controller";
application.register("flatpickr", FlatpickrController);

import YearSelectController from "./year_select_controller";
application.register("year-select", YearSelectController);

import PickrController from "./pickr_controller"
application.register("pickr", PickrController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import DashboardChartController from "./dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import NewsController from "./news_controller"
application.register("news", NewsController)

import DailyFoodCheckSearchController from "./daily_food_check_search"
application.register("daily-food-check-search", DailyFoodCheckSearchController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import BiometricLogSearchController from "./biometric_log_search"
application.register("biometric-log-search", BiometricLogSearchController)